module.exports = __webpack_public_path__ + "static/media/flow.e3812c4f.svg";